export const GET_COLUMNS = "GET_COLUMNS";
export const GET_COLUMNS_SUCCESS = "GET_COLUMNS_SUCCESS";
export const GET_COLUMNS_FAILED = "GET_COLUMNS_FAILED";

export const ADD_COLUMNS = "ADD_COLUMNS";
export const ADD_COLUMNS_SUCCESS = "ADD_COLUMNS_SUCCESS";
export const ADD_COLUMNS_FAILED = "ADD_COLUMNS_FAILED";

export const EDIT_COLUMNS = "EDIT_COLUMNS";
export const EDIT_COLUMNS_SUCCESS = "EDIT_COLUMNS_SUCCESS";
export const EDIT_COLUMNS_FAILED = "EDIT_COLUMNS_FAILED";

export const DELETE_COLUMNS = "DELETE_COLUMNS";
export const DELETE_COLUMNS_SUCCESS = "DELETE_COLUMNS_SUCCESS";
export const DELETE_COLUMNS_FAILED = "DELETE_COLUMNS_FAILED";